<template>
    <form @submit.prevent="handleReminder">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Set Up Reminder</p>
            </header>
            <section class="modal-card-body">
                <o-field label="User" :type="fieldType('user_id')">
                    <autocomplete-select type="user" :error="getError('user_id')" :value="userById(reminder.user_id)" v-model="reminder.user_id" />
                </o-field>

                <o-field label="Pick a Custom Date" :type="fieldType('remind_at')" :message="getError('remind_at')">
                    <datepicker v-model="reminder.remind_at" :value="reminder.remind_at" :is-time-picker="true" />
                </o-field>

                <o-field label="Description" :type="fieldType('description')" :message="getError('description')">
                    <o-input v-model="reminder.description" type="textarea"></o-input>
                </o-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
import HandlesForm from '../../mixins/HandlesForm';
import Datepicker from '../Datepicker';

    export default {
        mixins: [HandlesForm],

        components: {
            Datepicker
        },

        props: {
            referenceId: {
                type: Number
            },
            referenceType: {
                type: String
            },
            reminderId: {
                type: Number
            },
            reminderSnoozed: {
                type: Array,
                default: () => []
            }
        },

        mounted() {

            this.reminder.user_id = this.currentUserId

            if (this.reminderId) {
                let item = this.reminderById(this.reminderId)

                this.reminder = _.merge(this.reminder, {
                    id: item.id,
                    user_id: item.user_id,
                    description: item.description,
                    remind_at: moment(item.remind_at).format('Y-MM-DD H:m:s'),
                    reference_id: item.reference_id,
                    reference_type: item.reference_type
                })
            }
        },

        data () {
            return {
                reminder: {
                    id: null,
                    user_id: null,
                    description: null,
                    remind_at: moment({hour: 10, minute: 0}).format('Y-MM-DD H:m:s'),
                    reference_id: this.referenceId,
                    reference_type: this.referenceType
                },
            }
        },

        methods: {
            ...mapActions(['createOrUpdateReminder']),

            handleReminder () {
                let submit = this.wrapSubmit(this.createOrUpdateReminder)

                if (this.reminderSnoozed.length > 0){
                  this.reminderSnoozed.map((item) => {
                    submit({
                      id: item.id,
                      user_id: this.reminder.user_id,
                      description: this.reminder.description,
                      remind_at: moment(this.reminder.remind_at).format('Y-MM-DD H:m:s'),
                      reference_id: item.reference_id,
                      reference_type: item.reference_type
                    }).then(res => {
                      this.$parent.$parent.$emit('update:active', false)
                      return res
                    })
                  })
                }else{
                  if (!this.reminder.user_id) this.reminder.user_id = this.currentUserId
                  submit(this.reminder)
                      .then(res => {
                        this.successMessage('Reminder successfull set up')
                        this.$parent.$parent.$emit('update:active', false)
                        this.$parent.$parent.close()
                        return res
                      })
                }
            }
        },

        computed: {
            ...mapGetters(['currentUserId', 'reminderById', 'userById'])
        }
    }
</script>
